var Shuffle = require('shufflejs');

var Shuffler = function (element) {
	this.element = element;
	this.shuffle = new Shuffle(element, {});

	this._activeFilters = [];
	this.addFilterButtons();
};

Shuffler.prototype.toArray = function (arrayLike) {
	return Array.prototype.slice.call(arrayLike);
};

Shuffler.prototype.addFilterButtons = function () {
	var options = document.querySelector('.filter-options');

	if (!options) {
		return;
	}

	var filterButtons = this.toArray(
		options.querySelectorAll('div > button')
	);

	filterButtons.forEach(function (button) {
		button.addEventListener('click', this._handleFilterClick.bind(this), false);
	}, this);
};

Shuffler.prototype._handleFilterClick = function (evt) {
	var btn = evt.currentTarget;
	var isActive = btn.classList.contains('active');
	var btnGroup = btn.getAttribute('data-group');
	this._removeActiveClassFromChildren(btn.parentNode.parentNode);

	var filterGroup;
	if (isActive) {
		btn.classList.remove('active');
		filterGroup = Shuffle.ALL_ITEMS;
	} else {
		btn.classList.add('active');
		filterGroup = btnGroup;
	}

	this.shuffle.filter(filterGroup);
};

Shuffler.prototype._removeActiveClassFromChildren = function (parent) {
	var children = parent.children;
	for (var i = children.length - 1; i >= 0; i--) {
		children[i].children[0].classList.remove('active');
	}
};

document.addEventListener('DOMContentLoaded', function () {
	window.shuffler = new Shuffler(document.getElementById('results'));
});
